// Guide data for each unit
// Contains structured guide content with key phrases and grammar tips

import { unitsData } from "../lessons/lessonData.ts";

export interface GuidePhraseSentence {
  phrase_word: number[]; // Array of word bank IDs
}

export interface GuidePhrase {
  phrase_sentences: GuidePhraseSentence[];
}

export interface GuideContent {
  unit: number;
  section: number;
  title: string;
  description: string;
  keyPhraseTitle: string;
  phrases: GuidePhrase[];
}

export interface GuideData {
  guide_id: number;
  guide_content: GuideContent;
}

export const guideData: GuideData[] = [
  {
    guide_id: 1,
    guide_content: {
      unit: 1,
      section: 1,
      title: "Panduan Unit 1",
      description:
        "Pelajari frasa kunci bahasa Batak Toba untuk menyebutkan nama, asal, umur, pekerjaan, serta kata ganti dasar.",
      keyPhraseTitle: unitsData[0].title,
      phrases: [
        // Lesson 1
        {
          phrase_sentences: [
            { phrase_word: [1] }, // anakkon
            { phrase_word: [5] }, // do
            { phrase_word: [4] }, // Rinto
          ],
        },

        // Lesson 2
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [6] }, // martonun
            { phrase_word: [44] }, // martonun
            { phrase_word: [7] }, // Balige
          ],
        },

        // Lesson 3
        {
          phrase_sentences: [
            { phrase_word: [8] }, // pekerjaanku
            { phrase_word: [9] }, // guru
          ],
        },

        // Lesson 4
        {
          phrase_sentences: [
            { phrase_word: [10] }, // ia
            { phrase_word: [5] }, // do
            { phrase_word: [9] }, // guru
          ],
        },
      ],
    },
  },
  {
    guide_id: 2,
    guide_content: {
      unit: 2,
      section: 1,
      title: "Panduan Unit 2",
      description:
        "Pelajari kosakata dan frasa bahasa Batak Toba untuk mengenal anggota keluarga, struktur keluarga, dan hubungan kekerabatan.",
      keyPhraseTitle: unitsData[1].title,
      phrases: [
        // Lesson 1: Anggota Keluarga Inti
        {
          phrase_sentences: [
            { phrase_word: [11] }, // amang
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [13] }, // namangido
            { phrase_word: [2] }, // au
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [12] }, // ina
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [14] }, // marsitutur
            { phrase_word: [24] }, // hami
          ],
        },
        // Lesson 2: Struktur Keluarga
        {
          phrase_sentences: [
            { phrase_word: [15] }, // ompung doli
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [17] }, // lambok
          ],
        },
        // Lesson 3: Panggilan dan Hubungan
        {
          phrase_sentences: [
            { phrase_word: [18] }, // parumaen boru
            { phrase_word: [19] }, // ku
            { phrase_word: [21] }, // baikkon
          ],
        },
        // Lesson 4: Marga dan Kekerabatan
        {
          phrase_sentences: [
            { phrase_word: [22] }, // marga
            { phrase_word: [2] }, // au
            { phrase_word: [23] }, // siagian
          ],
        },
        // Lesson 5: Percakapan Seputar Keluarga
        {
          phrase_sentences: [
            { phrase_word: [34] }, // amahu
            { phrase_word: [30] }, // si Binsar
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [22] }, // marga
            { phrase_word: [2] }, // au
            { phrase_word: [31] }, // Manurung
          ],
        },
      ],
    },
  },
  {
    guide_id: 3,
    guide_content: {
      unit: 3,
      section: 1,
      title: "Panduan Unit 3",
      description:
        "Pelajari kosakata dan frasa kunci bahasa Batak Toba untuk menyebutkan umur, bilangan, pekerjaan, dan menanyakan profesi.",
      keyPhraseTitle: unitsData[2].title,
      phrases: [
        // Lesson 1: Umur dan Bilangan
        {
          phrase_sentences: [
            { phrase_word: [25] }, // piro
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [26] }, // tuamu
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [27] }, // tuaku
            { phrase_word: [86] }, // sapuluh
            { phrase_word: [29] }, // taon
          ],
        },
        // Lesson 2: Menyebutkan Profesi
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [5] }, // do
            { phrase_word: [30] }, // parguron
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [10] }, // ia
            { phrase_word: [5] }, // do
            { phrase_word: [9] }, // guru
          ],
        },
        // Lesson 3: Bertanya dan Menjawab tentang Profesi
        {
          phrase_sentences: [
            { phrase_word: [31] }, // aha
            { phrase_word: [5] }, // do
            { phrase_word: [32] }, // pangalusmu
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [33] }, // mangalusi
          ],
        },
        // Lesson 4: Profesi dalam Keluarga
        {
          phrase_sentences: [
            { phrase_word: [34] }, // amahu
            { phrase_word: [5] }, // do
            { phrase_word: [35] }, // paruma
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [36] }, // inangku
            { phrase_word: [5] }, // do
            { phrase_word: [9] }, // guru
          ],
        },
      ],
    },
  },

  {
    guide_id: 4,
    guide_content: {
      unit: 4,
      section: 1,
      title: "Panduan Unit 4",
      description:
        "Pelajari frasa inti tentang tempat tinggal dan lingkungan dalam bahasa Batak Toba.",
      keyPhraseTitle: unitsData[3].title,
      phrases: [
        // Lesson 1: Menyebutkan Tempat Tinggal
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [42] }, // martonggo
            { phrase_word: [44] }, // di
            { phrase_word: [7] }, // Balige
          ],
        },
        // Lesson 2: Nama Tempat dan Jenis Lingkungan
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [6] }, // martonun
            { phrase_word: [44] }, // di
            { phrase_word: [46] }, // huta
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [6] }, // martonun
            { phrase_word: [44] }, // di
            { phrase_word: [47] }, // lumban
          ],
        },
        // Lesson 3: Lingkungan Sekitar
        {
          phrase_sentences: [
            { phrase_word: [40] }, // bagas
            { phrase_word: [44] }, // di
            { phrase_word: [59] }, // dapot
            { phrase_word: [53] }, // huria
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [42] }, // martonggo
            { phrase_word: [44] }, // di
            { phrase_word: [59] }, // dapot
            { phrase_word: [52] }, // parguruan
          ],
        },
        // Lesson 4: Arah dan Lokasi
        {
          phrase_sentences: [
            { phrase_word: [52] }, // parguruan
            { phrase_word: [44] }, // di
            { phrase_word: [57] }, // jolo
            { phrase_word: [53] }, // huria
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [51] }, // pajak
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [60] }, // lompak
            { phrase_word: [84] }, // dari
            { phrase_word: [40] }, // bagas
          ],
        },
        // Lesson 5: Percakapan Seputar Tempat Tinggal dan Lingkungan
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [42] }, // martonggo
            { phrase_word: [44] }, // di
            { phrase_word: [45] }, // kota
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [99] }, // do without indonesian
            { phrase_word: [6] }, // martonun
            { phrase_word: [44] }, // di
            { phrase_word: [47] }, // lumban
          ],
        },
      ],
    },
  },
  {
    guide_id: 5,
    guide_content: {
      unit: 5,
      section: 1,
      title: "Panduan Unit 5",
      description:
        "Pelajari frasa inti kegiatan sehari-hari dalam bahasa Batak Toba.",
      keyPhraseTitle: unitsData[4].title,
      phrases: [
        // Lesson 1: Aktivitas Pagi Hari
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [61] }, // mangalak
            { phrase_word: [81] }, // jam
            { phrase_word: [82] }, // 6
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [10] }, // ia
            { phrase_word: [62] }, // manigos
            { phrase_word: [83] }, // sude
          ],
        },
        // Lesson 2: Aktivitas Siang Hari
        {
          phrase_sentences: [
            { phrase_word: [10] }, // ia
            { phrase_word: [33] }, // mangalusi
            { phrase_word: [44] }, // di
            { phrase_word: [51] }, // pajak
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [37] }, // anggiku
            { phrase_word: [67] }, // manungkun
            { phrase_word: [44] }, // di
            { phrase_word: [52] }, // parguruan
          ],
        },
        // Lesson 3: Aktivitas Sore dan Malam Hari
        {
          phrase_sentences: [
            { phrase_word: [24] }, // hami
            { phrase_word: [72] }, // martangiang
            { phrase_word: [84] }, // dari
            { phrase_word: [53] }, // huria
          ],
        },
        {
          phrase_sentences: [
            { phrase_word: [10] }, // ia
            { phrase_word: [74] }, // mandok TV
            { phrase_word: [44] }, // di
            { phrase_word: [40] }, // bagas
          ],
        },
        // Lesson 4: Rutinitas Harian
        {
          phrase_sentences: [
            { phrase_word: [76] }, // sude ari
            { phrase_word: [2] }, // au
            { phrase_word: [67] }, // manungkun
            { phrase_word: [44] }, // di
            { phrase_word: [40] }, // bagas
          ],
        },
        // Lesson 5: Percakapan Kegiatan
        {
          phrase_sentences: [
            { phrase_word: [2] }, // au
            { phrase_word: [75] }, // mamate
            { phrase_word: [81] }, // jam
            { phrase_word: [86] }, // 10
            { phrase_word: [79] }, // gabeng
          ],
        },
      ],
    },
  },
  // Add more guides as needed
];
